import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export const VI_STATUS_HEADER = 'Vi-Status';
export const HTTP_STATUS_SERVICE_UNAVAILABLE = 503;

export enum MaintenanceStatus {
  OPERATIONAL = 'operational',
  DEGRADED_PERFORMANCE = 'degraded_performance',
  PARTIAL_OUTAGE = 'partial_outage',
  MAYOR_OUTAGE = 'major_outage',
  MAINTENANCE = 'under_maintenance',
  UNKNOWN = 'unknown',
}

export function isRecoverableImpact(status: MaintenanceStatus): boolean {
  if (!status) {
    return true;
  }

  return [
    MaintenanceStatus.OPERATIONAL,
    MaintenanceStatus.DEGRADED_PERFORMANCE,
    MaintenanceStatus.PARTIAL_OUTAGE,
    MaintenanceStatus.UNKNOWN,
  ].includes(status);
}

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    tap((evt) => {
      if (evt instanceof HttpResponse) {
        if (evt.headers && evt.headers.has(VI_STATUS_HEADER)) {
          const maintenanceStatus = evt.headers.get(VI_STATUS_HEADER) as MaintenanceStatus;
          if (!isRecoverableImpact(maintenanceStatus)) {
            router.navigateByUrl('/maintenance', { replaceUrl: true });
          }
        }
      }
    }),
    catchError((err) => {
      const maintenanceStatus = err.headers.get(VI_STATUS_HEADER) as MaintenanceStatus;
      if (
        err instanceof HttpErrorResponse &&
        err.status === HTTP_STATUS_SERVICE_UNAVAILABLE &&
        err.headers &&
        err.headers.has(VI_STATUS_HEADER) &&
        !isRecoverableImpact(maintenanceStatus)
      ) {
        router.navigateByUrl('/maintenance', { replaceUrl: true });
      }
      return throwError(err);
    })
  );
};
